<template>
  <a-modal :title="title"
           :width="800"
           :visible="visible"
           :confirmLoading="confirmLoading"
           @ok="handleOk"
           @cancel="handleCancel"
           :cancelText="$t('button.close')">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('label.name')">
          <a-input v-decorator="['itemText', validatorRules.itemText]"
                   :read-only="checkField('itemText')"
                   @click="openLangModal('itemText', true)"
                   :placeholder="$t('label.pleaseEnterTheName')" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('label.dataValue')">
          <a-input :placeholder="$t('label.pleaseEnterDataValue')" v-decorator.trim="['itemValue', validatorRules.itemValue]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('label.description')">
          <a-input v-decorator="['description']"
                   :read-only="checkField('description')"
                   @click="openLangModal('description', false)"
                   :placeholder="$t('label.pleaseEnterADescription')" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('label.sortByVal')">
          <a-input-number :min="1" v-decorator="['sortOrder', { initialValue: 1 }]" />
          {{ $t('label.smallerFront') }}
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('label.enabledOrNot')" hasFeedback>
          <a-switch :checkedChildren="$t('label.enable')" :unCheckedChildren="$t('label.disable')" @change="onChose" v-model="visibleCheck" />
        </a-form-item>
      </a-form>
    </a-spin>
    <mtc-lang-modal />
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { addDictItem, editDictItem } from '@/api/api'
import { getAction } from '@api/manage'
import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
import langInputMixin from '@/mixins/langInputMixin'
import { resetLangFieldMap, setLangInputParams } from '@/utils/langUtils'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'DictItemModal',
  mixins: [mtcLangModalMixin, langInputMixin],
  data() {
    return {
      title: '操作',
      visible: false,
      visibleCheck: true,
      model: {},
      dictId: '',
      status: 1,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      // form: this.$form.createForm(this),
      validatorRules: {
        itemText: { rules: [{ required: true, message: this.$t('label.pleaseEnterTheName') }] },
        itemValue: { rules: [{ required: true, message: this.$t('label.pleaseEnterDataValue') }, { validator: this.validateItemValue }] }
      },
      mainTable: 'sys_dict_item'
    }
  },
  created() {
  },
  methods: {
    add(dictId) {
      this.dictId = dictId
      this.edit({})
    },
    edit(record) {
      this.getLangForm(this.mainTable)
      if (record.id) {
        this.dictId = record.dictId
        this.visibleCheck = record.status == 1? true: false
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.model.dictId = this.dictId
      this.model.status = this.status
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'itemText', 'itemValue', 'description', 'sortOrder'))
      })
    },
    onChose(checked) {
      if (checked) {
        this.status = 1
        this.visibleCheck = true
      } else {
        this.status = 0
        this.visibleCheck = false
      }
    },
    // 确定
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          values.itemText = (values.itemText || '').trim()
          values.itemValue = (values.itemValue || '').trim()
          values.description = (values.description || '').trim()
          let formData = Object.assign(this.model, values)
          formData.status = this.status
          let obj
          formData.sysLanguageList = setLangInputParams(this.mainTable, formData.id)
          if (!this.model.id) {
            obj = addDictItem
          } else {
            obj = editDictItem
          }
          that.confirmLoading = true
          obj(formData).then((res) => {
            if (res.success) {
              resetLangFieldMap()
              that.$message.success(res.message)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    // 关闭
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    validateItemValue(rule, value, callback) {
      let param = {
        itemValue: value,
        dictId: this.dictId
      }
      if (this.model.id) {
        param.id = this.model.id
      }
      if (value) {
        let reg = new RegExp('[`~!@#$^&*()=|{}\'.<>《》/?！￥（）—【】‘；：”“。，、？]')
        if (reg.test(value)) {
          callback(this.$t('label.dataValuesCannotContainSpecialChar'))
        } else {
          //update--begin--autor:lvdandan-----date:20201203------for：JT-27【数据字典】字典 - 数据值可重复
          getAction(`${MTC_AUTH}sys/dictItem/dictItemCheck`, param).then((res) => {
            if (res.success) {
              callback()
            } else {
              callback(res.message)
            }
          })
          //update--end--autor:lvdandan-----date:20201203------for：JT-27【数据字典】字典 - 数据值可重复
        }
      } else {
        callback()
      }
    }
  }
}
</script>
